import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { withTracker } from 'components/Tracker';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import { selectState } from 'redux/selectors';
import Dialog from '@material-ui/core/Dialog';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import DialogContent from '@material-ui/core/DialogContent';


const styles = {
  card: {
    maxWidth: 345,
    margin: 'auto',
    position: 'relative',
    height: '100%',
  },
  cardActionArea: {
    display: 'contents',
  },
  media: {
    objectFit: 'cover',
  },
  buttonLink: {
    textDecoration: 'none !important',
  },
};
class ProductCard extends Component {

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    feature: PropTypes.shape({}).isRequired,
    formatMessage: PropTypes.func.isRequired,
  };

  state = {
    open: false,
  };

  handleFeatureDialogClose = () => {
    this.setState({ open: false });
  }

  handleFeatureDialogOpen = () => {
    this.setState({ open: true });
  }

  showFeatureDialog = () => {
    this.handleFeatureDialogOpen();
  }

  render() {
    const { classes, feature, formatMessage } = this.props;
    const { category, open } = this.state;

    return (
      <Fragment>
        <Card className={classes.card}  >
          <CardActionArea className={classes.cardActionArea} onClick={() => this.showFeatureDialog()}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                {formatMessage(feature.title)}
              </Typography>
            </CardContent>
            <CardMedia
              component="img"
              alt={formatMessage('Image Not Available')}
              className={classes.media}
              height="140"
              image={feature.imageUrl}
              title={formatMessage(feature.title)}
            />
            <CardContent>
              <Typography component="p">
                {feature.description ? (`${feature.description.substr(0, 80)}${feature.description.length > 80 ? '...' : ''}`) : ''}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Dialog
          classes={{
            paper: classes.dialogContent,
            root: classes.dialog,
          }}
          maxWidth="md"
          onClose={this.handleFeatureDialogClose}
          open={open}
          scroll="body"
        >
          <DialogContent>
            <CardMedia
              component="img"
              alt={formatMessage('Image Not Available')}
              className={classes.media}
              image={feature.imageUrl}
              title={formatMessage(feature.title)}
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                {formatMessage(feature.title)}
              </Typography>
              <Typography component="p">
                {formatMessage(feature.description)}
              </Typography>
            </CardContent>
          </DialogContent>

        </Dialog>
      </Fragment>
    )
  }
}


/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'features')(state),
});

export default compose(
  setDisplayName('ProductCard'),
  connect(
    mapStateToProps,
  ),
  injectIntl,
  immutableToJS,
  withStyles(styles),
  withTracker,
)(ProductCard);
